export function chunkArray(array, size) {
    return array.length <= size
        ? [array]
        : [array.slice(0, size), ...chunkArray(array.slice(size), size)];
}
export function chunkArrayGeneric(array, size) {
    return array.length <= size
        ? [array]
        : [array.slice(0, size), ...chunkArrayGeneric(array.slice(size), size)];
}
